import React from 'react';

class ProgressBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fill: 0 };
  }

  componentDidMount() {
    setTimeout(function () {
      this.setState({ fill: this.props.percent });
    }.bind(this), 500);
  }

  render() {
    return (
      <div className="progress-bar-graph">
        <div className="progress-bar-graph-details">
          <div className={'progress-bar-graph-match progress-bar-graph-match--' + this.props.color}>
            {this.state.fill} Match
          </div>
          {/* <div className="progress-bar-graph-criteria">{this.props.matches}/{this.props.criteria} matching criteria</div> */}
        </div>
        <div className="progress-bar-graph-line">
            <div style={{ width: this.state.fill }} className={'progress-bar-graph-fill progress-bar-graph-fill--' + this.props.color}></div>
        </div>
      </div>
    )
  }
}

export default ProgressBar;
